<template>
    <div
        class="kgr-row kgr-postfix kgr-postfix--center kgr-postfix--tinyGutters"
    >
        <div
            class="kgr-postfix__fixed"
        >
            <kgr-pill-info
                :label="bookingLabel"
                :value="bookingValue"
            />
        </div>
        <div
            class="kgr-postfix__fixed"
        >
            <kgr-pill-info
                :label="attendanceLabel"
                :value="attendanceValue"
            />
        </div>
        <div
            class="kgr-postfix__fluid"
        ></div>
        <button
            name="btn-pdf"
            class="kgr-button kgr-button--accent kgr-postfix__fixed"
            @click="downloadExcel"
        >
            {{ $t('Teilnehmerliste herunterladen (Excel)') }}
        </button>
    </div>
</template>
<script>
import Offering from '../../../js/dto/offering/Offering.js';
import PillInfo from './PillInfo.vue';
import moment from 'moment';

export default {
    name: 'KgrOfferingStatOverview',
    components: {
        'kgr-pill-info': PillInfo,
    },
    props: {
        offering: {
            type: Offering,
            required: true,
        },
        appointments: {
            type: Array,
            required: true,
        },
        isTraining: {
            type: Boolean,
            required: true,
        },
        bookingFrom: {
            type: String,
            required: true,
        },
        bookingTo: {
            type: String,
            required: true,
        },
    },
    computed: {
        totalBooking() {
            return this.appointments.reduce(
                (previousValue, currentValue) => {
                    if ((currentValue.appointmentOverride && currentValue.appointmentOverride.isCanceled)) {
                        return previousValue;
                    }
                    let val = this.isTraining ? (currentValue.acceptedCount ?? 0) : (currentValue.bookingCount ?? 0);
                    return previousValue + val;
                },
                0,
            );
        },
        totalAppointments() {
            return this.appointments.filter(
                currentValue => {
                    return !((currentValue.appointmentOverride && currentValue.appointmentOverride.isCanceled))
                }
            );
        },
        bookingLabel() {
            return (this.isTraining ? this.$t('Zusagen') : this.$t('Buchungen'));
        },
        bookingValue() {
            return this.totalBooking + this.bookingLabelExtrasWithMaxParticipants;
        },
        bookingLabelExtrasWithMaxParticipants() {
            return this.offering.maxParticipants && this.offering.maxParticipants > 0 ? ' / ' + this.totalMaxParticipants + ' (' + this.getFixedNumber(this.avgBooking) + ' %)' : '';
        },
        totalMaxParticipants() {
            return (this.offering.maxParticipants && this.offering.maxParticipants > 0) ? this.totalAppointments.length * this.offering.maxParticipants : '';
        },
        avgBooking() {
            return (this.totalBooking * 100) / (this.offering.maxParticipants * this.appointments.length);
        },
        totalAttendance() {
            return this.appointments.reduce(
                (previousValue, currentValue) => {
                    if ((currentValue.appointmentOverride && currentValue.appointmentOverride.isCanceled)) {
                        return previousValue;
                    }
                    return previousValue + currentValue.attendancePresentCount ?? 0;
                },
                0,
            );
        },
        attendanceLabel() {
            return this.$t('Teilnahme');
        },
        attendanceValue() {
            return this.totalAttendance + ' / ' + this.totalBooking + this.attendanceLabelExtra;
        },
        attendanceLabelExtra() {
            return ' (' + this.getFixedNumber(this.avgAttendance) + ' %)';
        },
        avgAttendance() {
            return this.totalBooking > 0 ? this.totalAttendance * 100 / this.totalBooking : 0;
        },
    },
    methods: {
        getFixedNumber(num) {
            return (Math.round(num * 100) / 100).toFixed(2);
        },
        convertDate(date) {
            return moment(date, 'DD.MM.YYYY').format('YYYY-MM-DD');
        },
        downloadExcel() {
            window.location = `/api/club/offering/${this.offering.id}/appointments/${this.convertDate(this.bookingFrom)}/${this.convertDate(this.bookingTo)}/excel`;
        },
    },
}
</script>
